import React, { useEffect, useState } from 'react';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Button from '@mui/material/Button';

// Load module after Highcharts is loaded
require('highcharts/modules/exporting')(Highcharts);


const downloadCsv = async (data) => {
  let titles = Object.keys(data[0]).join(',')
  let csvContent = `${titles}\n${data.map(row => Object.values(row).join(',')).join('\n')}`;

  // Create a Blob object with the CSV content
  const blob = new Blob([csvContent], { type: 'text/csv' });

  // Create a temporary URL for the Blob
  const url = URL.createObjectURL(blob);

  // Create a hidden anchor element
  const a = document.createElement('a');
  a.href = url;
  a.download = 'Summary Analyzed.csv';

  // Trigger the download
  a.click();

  // Clean up (optional)
  window.URL.revokeObjectURL(url);
}


function parseIntoSeries(data) {
  let series = [];

  let col_headers = Object.keys(data[0]);
  let x_axis_header = col_headers[0];
  let series_headers = col_headers.splice(1);

  // find the different series
  for (let header_ind in series_headers) {
    let header = series_headers[header_ind];
    series.push({ name: header, type: 'line', data: [] })
    for (let row in data) {
      let sgi_value = parseFloat(data[row][header]);
      let date = parseInt(data[row][x_axis_header]);
      series[series.length - 1]['data'].push([date, sgi_value]);
    }
  }
  return series;
}

function Graph({ name, data }) {
  const [options, setOptions] = useState({});

  useEffect(() => {
    if (!data || !name) {
      console.log('No data or name provided');
      return;
    }
    let series = parseIntoSeries(data);

    let options = {
      chart: { type: 'spline' },
      title: { text: name, align: 'center' },
      yAxis: { title: { text: 'Skroot Growth Index (SGI)', style: { fontSize: '13pt' } } },
      xAxis: { 
        type: 'datetime', 
        title: { text: 'Date', style: { fontSize: '13pt' } },
        dateTimeLabelFormats: {
          second: '%l:%M %p',
          minute: '%l:%M %p',
          hour: "%l:%M %p",
       },
       labels: {
        rotation: -45,
       }
      },
      legend: { layout: 'horizontal', align: 'center', verticalAlign: 'bottom' },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:,.3f}</b><br/>',
        xDateFormat: "%a, %b %d, %l:%M %p",
      },
      series: series,  
      credits: {
        enabled: false
      }
    };
    setOptions(options);
  }, [name, data]);

  return (
    <div className="graph">
      <HighchartsReact highcharts={Highcharts} options={options} />
      <Button variant="contained" endIcon={<FileDownloadIcon />} onClick={() => downloadCsv(data)}>Download</Button>
    </div>
  );
}

export default Graph;